import React from 'react'

const UserContext = React.createContext({ userName: '', profilePicture: '' })

export const UserProvider = UserContext.Provider
export const UserConsumer = UserContext.Consumer
export default UserContext
